export var JIRA = 'jira';
export var JIRA_SERVICE_DESK = 'jsd'; // export const JIRA_SOFTWARE = "jsw";

export var CONFLUENCE = 'confluence';
export var HIPCHAT = 'hipchat';
export var BITBUCKET = 'bitbucket';
export var FECRU = 'fecru';
export var BAMBOO = 'bamboo';
export var CROWD = 'crowd';